var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Tooltip',{attrs:{"content":_vm.$t('whatsApp')}},[_vm._t("default",function(){return [_c('BaseButton',{class:[
        'OrderWhatsButton btn-link btn-simple btn-success',
        { Disabled: _vm.entity && _vm._.isEmpty(_vm.entity.customer.contacts) },
      ],attrs:{"size":"sm","icon":""},on:{"click":_vm.openWhats}},[_c('i',{staticClass:"fab fa-whatsapp"})])]},{"openWhats":_vm.openWhats})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }